module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-to-bottom-241ca8206368475d671a62c05d99ca84.svg";